import {PHIEU_IN_ENDPOINT, WF_TRACKER} from "../../../../utils/Constant";
import {TypeKeHoach} from "../models/KeHoachModel";
import {CODE_KE_HOACH} from "../../../../quan-ly-ke-hoach/Components/danh-sach-ke-hoach/constants/constansKeHoach";

export const WMS_STATUS = {
  build_plan: "build_plan",
  directDownline: "directDownline",
  build_plan_approved: "build_plan_approved",
};

export const CODE_KHAO_SAT = {
  KE_HOACH: 'X004',
  DAO_TAO: 'X011',
}

export const TYPE_KE_HOACH: TypeKeHoach[] = [
  {
    name: 'Kế hoạch chỉ dạo tuyến',
    code: CODE_KHAO_SAT.KE_HOACH,
    formThongTinChung: '',
    formVatTu: 'chidaotuyenphieukhaosat',
    pathApi: '',
    pathApiPrint:'',
    trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER,
    termModelType: "directDownline"
  }
];

export const TYPE_KE_HOACH_DAO_TAO = {
  CSHT:
    {
      name: 'Cơ sở hạ tầng',
      code: 'techTransferInfrastructureResponses',
      formVatTu: 'baocaokhaosatcosohatang',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: '',
      termModelType: ''
    },
  CAN_BO:
    {
      name: 'Đề xuất cử người hỗ trợ',
      code: 'supportStaffProposal',
      formVatTu: 'dohadexuatcunguoihotro',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: WF_TRACKER.HE_HOACH_DAO_TAO,
      termModelType: ''
    },
  KT_CHUYEN_MON:
    {
      name: 'Khả năng đáp ứng cử người hành nghề đi hỗ trợ kỹ thuật chuyên môn',
      code: 'professionalSupportCapability',
      formVatTu: 'dohadexuatcunguoihotro',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: WF_TRACKER.HE_HOACH_DAO_TAO,
      termModelType: ''
    },
  TRANG_THIET_BI:
    {
      name: 'Trang thiết bị',
      code: 'equipmentList',
      formVatTu: 'baocaokhaosattrangthietbi',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: '',
      termModelType: ''
    },
  NHU_CAU:
    {
      name: 'Xác nhận đáp ứng',
      code: 'confirmationStatus',
      formVatTu: 'dohaxacnhandapung',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: WF_TRACKER.HE_HOACH_DAO_TAO,
      termModelType: ''
    },
  KY_NANG:
    {
      name: 'Nhu cầu đào tạo kỹ năng mềm, quản lý, truyền thông',
      code: CODE_KHAO_SAT.DAO_TAO,
      formVatTu: 'nhucaudaotaokynangmemqltt',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: WF_TRACKER.HE_HOACH_DAO_TAO,
      termModelType: ''
    },
  BAO_CAO:
    {
      name: 'Báo cáo khảo sát',
      code: 'bcks',
      formThongTinChung: 'chidaotuyenbaocaophieukhaosat',
      formVatTu: '',
      pathApi: '',
      pathApiPrint:'',
      trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER,
      termModelType: "directDownline",
      type: 4,
    },
}

export const TYPE_KHAO_SAT = {
  BAO_CAO:
    {
      name: 'Báo cáo khảo sát',
      code: 'bcks',
      formThongTinChung: 'chidaotuyenbaocaophieukhaosat',
      formVatTu: '',
      pathApi: '',
      pathApiPrint:'',
      trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER,
      termModelType: "directDownline",
      type: 4,
    },
  DE_NGHI_CHUYEN_GIAO:
    {
      name: 'Đề nghị chuyển giao',
      code: '',
      formThongTinChung: 'chidaotuyenphieukhaosat',
      formVatTu: 'chidaotuyendenghichuyengiao',
      pathApi: '',
      pathApiPrint:'',
      trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER,
      termModelType: "directDownline",
      type: 4,
    },
}


export const OPTION_KHAO_SAT: TypeKeHoach[] = [
  {
    name: 'Chuyển giao kỹ thuật',
    code: CODE_KE_HOACH.KHCG,
    formThongTinChung: 'dohaphieukhaosat',
    formVatTu: 'chidaotuyenxacnhanphieukhaosat',
    pathApi: '',
    pathApiPrint:'',
    trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER,
    termModelType: "directDownline",
    type: 4,
  },
  {
    name: 'Hỗ trợ kỹ thuật chuyên môn',
    code: CODE_KE_HOACH.KHHT,
    formThongTinChung: 'dohahotrokythuatchuyenmonkhaosat',
    formVatTu: 'chidaotuyenthongtinbienban',
    pathApi: 'dohaquaylykehoach',
    pathApiPrint:'',
    trackerCode: WF_TRACKER.SURVEY_TECHNIQUE_SUPPORT,
    termModelType: "directDownline",
    type: 5,
  },
];
